const routes = [
    {
        path: "/campuses",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission:'campus_index'
        },
        //component_full_path: 'campus/pages/Index'
    }
];

export default routes;
